// This model class is no longer used, but kept for reference or future use
import { MonthYearEntry } from './month-year-entry.model';

export class GenerateInvoiceDto {
	invoiceNumber: string;
	currentDate: string;
	issueDate: string;
	dueDate: number;

	constructor(invoiceNumber: string, monthYear: MonthYearEntry, issueDate: string, dueDate: number) {
		this.invoiceNumber = invoiceNumber;
		this.currentDate = this.getFormattedMonthDate(monthYear);
		this.issueDate = issueDate;
		this.dueDate = dueDate;
	}

	private getFormattedMonthDate(monthYear: MonthYearEntry): string {
		const now = new Date();
		const y = monthYear.year ?? now.getFullYear();
		// monthValue is 1-based (e.g. Jan = 1), but JavaScript Date needs 0-based (Jan = 0),
		// so we subtract 1. If monthValue is missing, we take the current month (also converted to 1-based) first.
		const m = (monthYear.monthValue ?? now.getMonth() + 1) - 1;

		const date = new Date(y, m);
		return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-01`;
	}
}
